import React from 'react';
import { Drawer, Box, Typography, Button } from '@mui/material';

import { TP_COLORS } from '../../../../constants';
import { ISubTopic } from '../../../../store/SubTopicSlice';
import { ITopic } from '../../../../store/TopicSlice';
import { getSubjectColor } from '../../../../helper';
import DetailViewCard from '../../../../components/Card/DetailViewCard';

export interface IViewLoggerDrawer {
  open: boolean;
  onClose: () => void;
  subTopic: ISubTopic | undefined;
}

const ViewLoggerDrawer: React.FC<IViewLoggerDrawer> = ({
  open,
  onClose,
  subTopic,
}) => {
  let topic: ITopic | null = null;

  if (subTopic && subTopic.topic) {
    topic = subTopic.topic;
  }

  const subjectName = topic?.subject || '';
  const topicName = topic?.name;
  const subTopicName = subTopic?.name;
  const createdByName = subTopic?.createdBy
    ? `${subTopic?.createdBy.firstname}${
        subTopic?.createdBy.lastname ? ` ${subTopic?.createdBy.lastname}` : ''
      }`
    : '-';

  const updateByName = subTopic?.updatedBy
    ? `${subTopic?.updatedBy.firstname}${
        subTopic?.updatedBy.lastname ? ` ${subTopic?.updatedBy.lastname}` : ''
      }`
    : '-';

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => onClose()}
      PaperProps={{ style: { minWidth: '300px', maxWidth: '350px' } }}
    >
      <Box role="presentation" style={{ padding: '30px 15px' }}>
        <Typography variant="h6" fontWeight={600} sx={{ mb: '15px' }}>
          Modification Log
        </Typography>
        <div>
          <DetailViewCard
            title={subjectName}
            containerProps={{
              sx: {
                color: TP_COLORS.white,
                background: getSubjectColor(subjectName),
              },
            }}
          />
          <DetailViewCard
            title="Topic"
            description={topicName}
            titleProps={{ variant: 'caption' }}
            descriptionProps={{
              fontWeight: 600,
              variant: 'subtitle2',
            }}
          />
          <DetailViewCard
            title="Sub Topic"
            description={subTopicName}
            titleProps={{ variant: 'caption' }}
            descriptionProps={{
              fontWeight: 600,
              variant: 'subtitle2',
            }}
          />
          {subTopic?.createdBy && (
            <DetailViewCard
              title="Created By"
              description={createdByName}
              titleProps={{ variant: 'caption' }}
              descriptionProps={{
                fontWeight: 600,
                variant: 'subtitle2',
              }}
            />
          )}
          {subTopic?.updatedBy && (
            <DetailViewCard
              title="Updated By"
              description={updateByName}
              titleProps={{ variant: 'caption' }}
              descriptionProps={{
                fontWeight: 600,
                variant: 'subtitle2',
              }}
            />
          )}
          {subTopic?.sortingOrder && (
            <DetailViewCard
              title="Sorting Order"
              description={subTopic.sortingOrder.toString()}
              titleProps={{ variant: 'caption' }}
              descriptionProps={{
                fontWeight: 600,
                variant: 'subtitle2',
              }}
            />
          )}
        </div>
        <div style={{ marginTop: '30px' }}>
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            onClick={onClose}
          >
            Dismiss
          </Button>
        </div>
      </Box>
    </Drawer>
  );
};

export default ViewLoggerDrawer;
